module.exports = __webpack_public_path__ + "img/374.fc512790.png";